import { render, staticRenderFns } from "./item_store.vue?vue&type=template&id=e906910c&scoped=true&"
import script from "./item_store.vue?vue&type=script&lang=js&"
export * from "./item_store.vue?vue&type=script&lang=js&"
import style0 from "./item_store.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./item_store.vue?vue&type=style&index=1&id=e906910c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e906910c",
  null
  
)

export default component.exports